<script>

	import RadioButton from '../ui/RadioButton.svelte';

	export let field;
	export let response = [];

</script>

<style>
	.radiobuttons {
		padding: 0 1em 0.5em 1em;
		color: var(--fieldTextColor);
	}
	:global(.outline) .radiobuttons {
		color: var(--textColor);
	}
	:global(.linear.outline) .radiobuttons {
		padding: 0 0 0.5em 0;
	}
	:global(.linear.solid) .radiobuttons {
		padding: 0.3em 1em 0.5em 1em;
	}
</style>

{#if field.options}
	<div class="radiobuttons">
		{#each field.options as o}
			<p>
				<RadioButton>
					<input
						type="radio"
						id="azn_s_i_{field.ref}_{o.ref}"
						name={field.ref}
						bind:group={response}
						value={o.ref}
					>
				</RadioButton>
				<label for="azn_s_i_{field.ref}_{o.ref}">{o.name.EN}</label>
			</p>
		{/each}
	</div>
{/if}
